export default __webpack_public_path__ + "static/media/Compactheid-popup-image.cc19cfd9.png";